export default __webpack_public_path__ + "static/media/woocommerce-clientid-secret.9adaf11d.gif";